// import React from 'react'
// import { RadialBar, Pie } from '@ant-design/charts';
// import { useEffect, useRef } from 'react'

// const StaffLeaveChartGraph = ({ leavesOverviewOfStaff }) => {
//     {
//         const data = [
//             {
//                 type: 'Teachers',
//                 value: leavesOverviewOfStaff?.staffLeaveSummary?.Teacher ? leavesOverviewOfStaff?.staffLeaveSummary?.Teacher : 0
//             },
//             {
//                 type: 'Data Operators',
//                 value: leavesOverviewOfStaff?.staffLeaveSummary?.['Data Operator'] ? leavesOverviewOfStaff?.staffLeaveSummary?.['Data Operator'] : 0
//             },
//             {
//                 type: 'Operations',
//                 value: leavesOverviewOfStaff?.staffLeaveSummary?.Operation ? leavesOverviewOfStaff?.staffLeaveSummary?.Operation : 0
//             }
//         ];
//         const config = {
//             appendPadding: 10,
//             data,
//             angleField: 'value',
//             colorField: 'type',
//             color: ['#9876E6', '#99DED9', '#589DFF'],
//             radius: 0.8,
//             autoFit: true,
//             legend: false,
//             innerRadius: 0.68,
//             label: {
//                 type: 'inner',
//                 offset: '-50%',
//                 content: "",
//                 style: {
//                     fill: '#fff',
//                     fontSize: 14,
//                     textAlign: 'center',
//                 },
//             },
//             statistic: {
//                 title: false,
//                 content: {
//                     style: {
//                         whiteSpace: 'pre-wrap',
//                         overflow: 'hidden',
//                         textOverflow: 'ellipsis',
//                         fontSize: 8
//                     },
//                     customHtml: function customHtml() {
//                         return (
//                             <div>
//                                 <div style={{ fontSize: "20px", fontWeight: "700" }}>{/* {attendanceDataContainer?.monthlyAttendance?.averagePercentage} */}{leavesOverviewOfStaff?.staffLeaveSummary?.totalLeaves
//                                 }</div>
//                                 <div style={{ fontSize: "10px", color: "#191919", fontWeight: "300", marginLeft: "5px", marginTop: "8px", fontFamily: "roboto", color: "grey" }}>Total staff on leave</div>
//                             </div>
//                         )
//                     }
//                 },
//             },
//             annotations: [],
//         };

//         return (
//             <>
//                 <div
//                     style={{
//                         width: "240px",
//                         height: "355px"
//                     }}>
//                     <Pie {...config} />
//                 </div>
//             </>

//         )
//     }
// }

// export default StaffLeaveChartGraph
import React from "react";
import { Pie } from "@ant-design/charts";

const StaffLeaveChartGraph = ({ leavesOverviewOfStaff }) => {
    
  const teacher = leavesOverviewOfStaff?.Teacher || 0;
  const dataOperator = leavesOverviewOfStaff?.["Data Operator"] || 0;
  const operation = leavesOverviewOfStaff?.Operation || 0;

  const totalLeaves = teacher + dataOperator + operation;

  const data = [
    {
      type: "Teachers",
      value: teacher,
    },
    {
      type: "Data Operators",
      value: dataOperator,
    },
    {
      type: "Operations",
      value: operation,
    },
  ];

  const config = {
    appendPadding: 10,
    data,
    angleField: "value",
    colorField: "type",
    color: ["#9876E6", "#99DED9", "#589DFF"],
    radius: 0.8,
    innerRadius: 0.68,
    autoFit: true,
    legend: false,

    label: {
      type: "inner",
      offset: "-50%",
      content: "",
    },

    statistic: {
      title: false,
      content: {
        customHtml: () => {
          return `
            <div style="text-align:center">
              <div style="font-size:20px; font-weight:700">
                ${totalLeaves}
              </div>

              <div style=" font-size:10px; color:grey; margin-top:8px; " >
                Total staff on leave
              </div>
            </div>
          `;
        },
      },
    },
  };

  return (
    <div style={{ width: "240px", height: "355px", }} >
      <Pie {...config} />
    </div>
  );
};

export default React.memo(StaffLeaveChartGraph, (prevProps, nextProps) => {
  return (
    prevProps.leavesOverviewOfStaff?.Teacher === nextProps.leavesOverviewOfStaff?.Teacher &&
    prevProps.leavesOverviewOfStaff?.["Data Operator"] === nextProps.leavesOverviewOfStaff?.["Data Operator"] &&
    prevProps.leavesOverviewOfStaff?.Operation === nextProps.leavesOverviewOfStaff?.Operation
  );
});
